/**
 * tokenRefreshMiddleware — the access token had expired; refresh it and run the
 * command once more.
 *
 * Auth is the one failure worth retrying automatically, because it is the only one
 * where nothing ran server-side PROVABLY (the request was refused before the handler).
 * Network/5xx is ambiguous, 400/403 is a deliberate refusal, 429 is a cool-down already
 * surfaced by `ChatBanner`, and anything stream-side means the run exists.
 */

import type { CommandMiddleware } from 'src/content/ChatV2/commands/ICommand';
import { isAuthError } from 'src/content/ChatV2/lib/errors';
import logger from 'src/utils/logger';

export const tokenRefreshMiddleware: CommandMiddleware = {
  name: 'token-refresh',
  async intercept(invocation, next) {
    try {
      return await next();
    } catch (error) {
      if (!isAuthError(error)) {
        throw error;
      }
      const { kc, updateToken } = await import('src/keycloak');
      const refreshed = await updateToken(kc);
      if (!refreshed) {
        throw error;
      }
      logger.log('[chat] token refreshed mid-command; retrying once', {
        command: invocation.command.name,
        chatId: invocation.context.chatId,
        correlationId: invocation.context.correlationId
      });
      return await next();
    }
  }
};
